import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const DashboardAssigmentServiceConfig = {
  name: "DashboardAssigment",
  annotations: []
} as ServiceConfig;